import imageSizes from '~/constants/imageSizes'
import type { Definition } from '~/types'

export const PageOffices: Definition = {
  contentType: 'PageOffices',
  fields: [
    {
      id: 'pointsOfContact',
      name: 'Points of contact',
      type: 'Array',
      subType: 'ModuleMediaCard'
    },
    {
      id: 'description',
      name: 'Description',
      type: 'Symbol'
    },
    {
      id: 'image',
      name: 'Image',
      type: 'ModuleMedia',
      imageOptions: { sizes: imageSizes.columns12_5269 }
    }
  ]
}

export default {
  PageOffices
}
